import React from "react";
import CaseStudys from "../index";
import styles from "./styles.module.scss";
// import scentabookbanner from "../../../assets/casestudy/scentabookbanner.webp";
// import scentabook1stimg from "../../../assets/casestudy/scentabook1stimg.webp";
// import scentabook2ndimg from "../../../assets/casestudy/scentabook2ndimg.webp";
// import scentabook3rdimg from "../../../assets/casestudy/scentabook3rdimg.png";
import hilightlightingstudiobanner from "../../../assets/casestudy/hilightlightingstudiobanner.jpg";
import hilightlightingstudio1img from "../../../assets/casestudy/hilightlightingstudio1img.png";
import hilightlightingstudio2img from "../../../assets/casestudy/hilightlightingstudio2img.png";
import hilightlightingstudio3img from "../../../assets/casestudy/hilightlightingstudio3img.png";

import KumarPhotography from "../../../assets/img/KumarPhotoGraphy.png";
import Mongodbicon from "../../../assets/img/mongodbicon.svg";
import Nodeicon from "../../../assets/img/nodeicon.svg";
import Reacticon from "../../../assets/img/reacticon.svg";
import Expressicon from "../../../assets/img/expressicon.svg";
// import ZEEQRCaseStudy from "../../../assets/casestudy/ZEEQRCaseStudy.webp";
// import Ajtech2ndimg from "../../../assets/casestudy/ajtech2ndimg.webp";
import AryaFireAndSafety from "../../../assets/casestudy/aryafireandsafety.png";
import scienceblue1img from "../../../assets/casestudy/scienceblue1img.png";

const HilightLightingStudio = () => {
  const caseStudiesB = [
    {
      image: AryaFireAndSafety,
      title: "Arya Fire & Safety ",
      category: "Website Design",
      pagelink: "/aryafire-and-safety",
      link: "https://aryafireandsafety.com/",
    },
    {
      image: scienceblue1img,
      title: "Science blue",
      category: "Website Design",
      pagelink: "/science-blue",
      link: "https://scienceblue.co.in/",
    },
  ];
  const servicesB = [
    { label: "UI & UX Design", link: "https://metasoft.ae/services" },
    { label: "Web Development", link: "https://metasoft.ae/services" },
    { label: "Performance Optimization", link: "https://metasoft.ae/services" },
    { label: "SEO", link: "https://metasoftdm.com/marketing-solutions/seo/" },
  ];
  return (
    <CaseStudys
      title="HilightLightingStudio"
      caseStudies={caseStudiesB}
      subtitle="Illuminating Spaces with Style and Expertise"
      header="Illuminating Spaces with Style and Expertise"
      // websiteUrl="https://aryafireandsafety.com/"
      industry="Lighting Solutions & Interior Lighting"
      services={servicesB}
      description={
        <>
          <span>Hilight Lighting Studio </span> Arya Fire & Safety is a trusted
          fire protection company committed to delivering reliable, compliant,
          and high-quality safety solutions for businesses and homes. To
          showcase their expertise and comprehensive range of products and
          services, we developed a clean and professional digital presence that
          reflects their credibility and long-standing commitment to safety. The
          website highlights their equipment, installation services, and
          training programs with clarity, offering users a smooth browsing
          experience that builds trust and makes it easy to explore and
          understand their fire safety offerings.
        </>
      }
      objective={{
        heading:
          "Developing a Modern and Informative Digital Experience for Lighting Solutions",
        content: (
          <>
            <p className={styles.projectText}>
              The objective of the Hilight Lighting Studio website project was
              to create a visually appealing and professional digital presence
              that reflects the brand’s expertise in stylish and functional
              lighting solutions. Our goal was to design a clean, organized
              platform that clearly showcases their range of lighting fixtures,
              custom designs, and installation services. This project aimed to
              communicate Hilight Lighting Studio’s credibility, highlight their
              creativity and years of industry experience, and provide users
              with a seamless browsing experience that simplifies
              discovery—ultimately helping homeowners and businesses find the
              right lighting solutions with confidence while strengthening
              engagement in a competitive interior lighting market.
            </p>
          </>
        ),
      }}
      process={{
        heading: "How We Designed a Professional and Intuitive Website",
        content: (
          <>
            <p className={styles.projectText}>
              The project started with a detailed understanding of Hilight
              Lighting Studio’s brand identity, design philosophy, and the needs
              of clients seeking innovative lighting solutions. Using these
              insights, we crafted a user journey that emphasized inspiration,
              easy exploration, and clear presentation of their diverse product
              range. In the design phase, we focused on elegant layouts,
              high-quality visuals, and intuitive navigation to reflect both
              creativity and professionalism. Development prioritized a
              responsive, fast-loading platform with seamless mobile
              performance, ensuring users could effortlessly browse fixtures,
              view installations, and access service details. Continuous
              feedback and iterative testing ensured the final website delivered
              a polished, engaging, and confidence-building experience for every
              visitor.
            </p>
          </>
        ),
      }}
      impact={{
        heading:
          "How the New Online Presence Boosted Arya Fire & Safety’s Customer Engagement",
        content: (
          <>
            <p className={styles.projectText}>
              The launch of the Hilight Lighting Studio website elevated the
              brand’s online presence by giving customers a visually engaging
              and informative way to discover their diverse lighting solutions.
              The refined layout, smooth navigation, and thoughtfully curated
              content made it easier for users to browse products, understand
              features, and find inspiration for their spaces. With improved
              mobile performance, quicker access to categories, and a more
              polished overall experience, the website has helped boost user
              interaction and expand the brand’s visibility in the interior
              lighting market. As a result, the platform now serves as a
              reliable, aesthetically pleasing touchpoint that supports
              confident decision-making and reinforces Hilight Lighting Studio’s
              reputation for quality and style.
            </p>
          </>
        ),
      }}
      conclusion={{
        heading: "Wrapping Up the Project",
        content: (
          <>
            <p className={styles.projectText}>
              In conclusion, the Hilight Lighting Studio website successfully
              captures the brand’s commitment to stylish, high-quality, and
              thoughtfully designed lighting solutions. With its clean visual
              approach and user-focused functionality, the platform now acts as
              an effective showcase for their products while helping customers
              explore options with clarity and confidence. This project not only
              strengthened the brand’s digital identity but also enhanced
              Hilight Lighting Studio’s position within the competitive lighting
              and interior design market—supporting continued growth and
              reinforcing their reputation as a trusted source for modern
              illumination.
            </p>
          </>
        ),
      }}
      heroImage={hilightlightingstudiobanner} // Add the hero image
      projectImage={hilightlightingstudio1img}
      projectImage2={hilightlightingstudio2img}
      projectImage3={hilightlightingstudio3img}
      // Add the project image
      technologies={[
        { name: "MongoDB", icon: Mongodbicon },
        { name: "Node.js", icon: Nodeicon },
        { name: "React", icon: Reacticon },
        { name: "Express.js", icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Aug 2025" // Add the launch date
    />
  );
};

export default HilightLightingStudio;
